import { Component, Inject } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { EnvironmentConfig } from '@shared/interfaces/environment-config';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-nav-banner',
  imports: [TranslateModule],
  templateUrl: './nav-banner.component.html',
})
export class NavBannerComponent {
  readonly advices = this.environmentConfig.config.advices;

  constructor(@Inject(ENVIRONMENT_CONFIG) public environmentConfig: EnvironmentConfig) {}
}
